<script>
export default {
  name: "CompletionActionDialog",
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue", "next-order", "reset"],
  methods: {
    onNextOrder() {
      this.$emit("next-order")
    },
    onReset() {
      this.$emit("reset")
    }
  }
}
</script>

<template>
  <q-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" persistent>
    <q-card class="confirm-modal">
      <q-card-section class="q-pb-sm">
        <div class="text-h6">포장 완료</div>
      </q-card-section>
      <q-card-section class="q-pt-none">
        현재 오더 포장이 완료되었습니다. 다음 오더를 시작하거나 화면을 초기화하세요.
      </q-card-section>
      <q-card-actions align="right" class="q-pa-md q-pt-none">
        <q-btn
          color="red"
          flat
          label="초기화"
          @click="onReset"
        />
        <q-btn
          color="primary"
          label="다음 오더 시작"
          @click="onNextOrder"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<style scoped lang="scss">
.confirm-modal {
  width: 420px;
  max-width: 92vw;
}
</style>
